/**
 * Vocabulário comum dos canais de marketing (e-mail, SMS, push).
 *
 * Nada aqui é de um canal só. O que é do e-mail (template, identidade de
 * envio, bloco do Beefree) mora em `features/email-marketing/model/types.ts`;
 * o que é do SMS, em `features/sms-marketing/model/types.ts`.
 */

export type CampaignStatus =
  | 'draft'
  | 'scheduled'
  | 'sending'
  | 'sent'
  | 'paused'
  | 'failed'
  | 'cancelled';

export type RecipientStatus = 'queued' | 'delivered' | 'opened' | 'clicked' | 'rejected' | 'unsubscribed';

export type SendMode = 'now' | 'later';

/** Canal que consome cota por slot. O push não entra: o disparo é nosso. */
export type QuotaChannel = 'email' | 'sms';

export interface ChannelCopy {
  /** Nome do canal no texto corrido: "cota para e-mail". */
  label: string;
  /** Unidade contada na cota, no plural: "8.000 e-mails". */
  unit: string;
  /** Bloqueio quando o conteúdo ainda não gera unidade por pessoa. */
  missingUnits?: string;
}

/**
 * Uma tabela em vez de `channel === 'email' ? … : …` espalhado pela revisão,
 * pelo banner e pela reserva de slot. Canal novo não compila sem a sua linha.
 */
export const CHANNEL_COPY: Record<QuotaChannel, ChannelCopy> = {
  email: { label: 'e-mail', unit: 'e-mails' },
  sms: { label: 'SMS', unit: 'SMS', missingUnits: 'Escreva o texto do SMS.' },
};

/** Público congelado no momento em que a campanha foi montada. */
export interface AudienceSnapshot {
  audienceId: string;
  audienceName: string;
  total: number;
  eligible: number;
  excludedNoConsent: number;
  excludedUnsubscribed: number;
  excludedInvalid: number;
}

/** Público disponível para escolher no wizard. */
export interface AudienceSegment {
  id: string;
  name: string;
  description: string;
  total: number;
  eligible: number;
  excludedNoConsent: number;
  excludedUnsubscribed: number;
  excludedInvalid: number;
}

/** Fotografia da cota de um canal. Os limites internos são da Fixe, não do provedor. */
export interface AccountCapacity {
  planName: string;
  cycleLimit: number;
  sent: number;
  available: number;
  renewsOn: string;
  transactionalReserve: number;
  companyLimit: number;
  campaignLimit: number;
}

export interface MergeField {
  token: string;
  label: string;
  sample: string;
}

export interface SendPoint {
  label: string;
  sent: number;
  delivered: number;
}

export interface SendErrorRow {
  id: string;
  code: string;
  message: string;
  count: number;
}

/**
 * Página de destinatários do detalhe. A API pagina (`?page=&pageSize=`);
 * a tela filtra só o que está na página carregada.
 */
export interface RecipientsPage<Row> {
  page: number;
  pageSize: number;
  total: number;
  rows: Row[];
}
